module.exports = __webpack_public_path__ + "static/media/contact_fallback.e07ad9e9.svg";